module.exports = __webpack_public_path__ + "static/media/Handtücher_.61461aca.png";